<h1 mat-dialog-title>Example National Identifiers</h1>

<mat-dialog-content aria-live="polite">
    <mat-card appearance="outlined" class="af-mat-card mat-elevation-z">
        <mat-card-content>
            <h2 class="bottom-space">Country and ID Type</h2>

            <mat-divider aria-hidden="true" class="field-space"></mat-divider>

            <h3><strong>Australia:</strong></h3>

            <ul class="ul-no-style">
                <li>Tax File Number (TFN)</li>
            </ul>

            <mat-divider aria-hidden="true" class="field-space"></mat-divider>

            <h3><strong>Bangladesh:</strong></h3>

            <ul class="ul-no-style">
                <li>Electronic Tax Identification Number</li>
                <li>National ID (NID) Number</li>
                <li>Tax Identification Number</li>
            </ul>

            <mat-divider aria-hidden="true" class="field-space"></mat-divider>

            <h3><strong>Belgium:</strong></h3>

            <ul class="ul-no-style">
                <li>ID Card Number</li>
                <li>National Register Number</li>
                <li>Social Insurance (SIS) Number</li>
            </ul>

            <mat-divider aria-hidden="true" class="field-space"></mat-divider>

            <h3><strong>Brazil:</strong></h3>

            <ul class="ul-no-style">
                <li>CPF Number</li>
                <li>CTPS Number</li>
                <li>Foreign National Registration (RNE) Number</li>
                <li>General Registration (RG) Number</li>
                <li>PIS Number</li>
                <li>Voter Registration Number</li>
            </ul>

            <mat-divider aria-hidden="true" class="field-space"></mat-divider>

            <h3><strong>Canada:</strong></h3>

            <ul class="ul-no-style">
                <li>Social Insurance Number (SIN)</li>
            </ul>

            <mat-divider aria-hidden="true" class="field-space"></mat-divider>

            <h3><strong>Chile:</strong></h3>

            <ul class="ul-no-style">
                <li>RUT Number</li>
                <li>RUN (Rol Único Nacional) number</li>
            </ul>

            <mat-divider aria-hidden="true" class="field-space"></mat-divider>

            <h3><strong>China:</strong></h3>

            <ul class="ul-no-style">
                <li>Citizen ID Number</li>
            </ul>

            <mat-divider aria-hidden="true" class="field-space"></mat-divider>

            <h3><strong>Costa Rica:</strong></h3>

            <ul class="ul-no-style">
                <li>ID Card Number</li>
                <li>Social Security Number (NSS)</li>
            </ul>

            <mat-divider aria-hidden="true" class="field-space"></mat-divider>

            <h3><strong>Denmark:</strong></h3>

            <ul class="ul-no-style">
                <li>Central Person Register Number (CPR Nr)</li>
            </ul>

            <mat-divider aria-hidden="true" class="field-space"></mat-divider>

            <h3><strong>Egypt:</strong></h3>

            <ul class="ul-no-style">
                <li>Insurance Number</li>
                <li>National ID Number</li>
            </ul>

            <mat-divider aria-hidden="true" class="field-space"></mat-divider>

            <h3><strong>France:</strong></h3>

            <ul class="ul-no-style">
                <li>Social Security ID (INSEE) Number</li>
            </ul>

            <mat-divider aria-hidden="true" class="field-space"></mat-divider>

            <h3><strong>Germany:</strong></h3>

            <ul class="ul-no-style">
                <li>Social Insurance Number (SVNR)</li>
                <li>Tax Number (Steuernr.)</li>
            </ul>

            <mat-divider aria-hidden="true" class="field-space"></mat-divider>

            <h3><strong>Ghana:</strong></h3>

            <ul class="ul-no-style">
                <li>Social Security Number</li>
            </ul>

            <mat-divider aria-hidden="true" class="field-space"></mat-divider>

            <h3><strong>Greece:</strong></h3>

            <ul class="ul-no-style">
                <li>IKA Registration Number</li>
                <li>Social Security Number (AMKA)</li>
                <li>Tax Registration Number (ΑΦΜ)</li>
            </ul>

            <mat-divider aria-hidden="true" class="field-space"></mat-divider>

            <h3><strong>Guernsey:</strong></h3>

            <ul class="ul-no-style">
                <li>National Insurance (NI) Number</li>
            </ul>

            <mat-divider aria-hidden="true" class="field-space"></mat-divider>

            <h3><strong>Hong Kong:</strong></h3>

            <ul class="ul-no-style">
                <li>HKID Number</li>
                <li>MPF (Mandatory Provident Fund) Account Number</li>
            </ul>

            <mat-divider aria-hidden="true" class="field-space"></mat-divider>

            <h3><strong>India:</strong></h3>

            <ul class="ul-no-style">
                <li>Aadhaar</li>
                <li>EPF Number</li>
                <li>ESIC Insurance Number</li>
                <li>Permanent Account Number (PAN)</li>
                <li>Universal Account Number</li>
            </ul>

            <mat-divider aria-hidden="true" class="field-space"></mat-divider>

            <h3><strong>Indonesia:</strong></h3>

            <ul class="ul-no-style">
                <li>BPJS Kesehatan</li>
                <li>BPJS Ketenagakerjaan</li>
                <li>Identity Card (KTP) Number</li>
                <li>Social Security Number (Nomor Jaminan Sosial)</li>
                <li>Tax Number (Nomor Pajak)</li>
            </ul>

            <mat-divider aria-hidden="true" class="field-space"></mat-divider>

            <h3><strong>Ireland:</strong></h3>

            <ul class="ul-no-style">
                <li>Personal Public Service Number (PPS no)</li>
            </ul>

            <mat-divider aria-hidden="true" class="field-space"></mat-divider>

            <h3><strong>Italy:</strong></h3>

            <ul class="ul-no-style">
                <li>Accident Insurance Number (INAIL)</li>
                <li>Executive Pension (INPDAI) Number</li>
                <li>Fiscal Code (CF)</li>
                <li>Supplemental Pension Number (PREVINDAI)</li>
            </ul>

            <mat-divider aria-hidden="true" class="field-space"></mat-divider>

            <h3><strong>Japan:</strong></h3>

            <ul class="ul-no-style">
                <li>Alien Registration Certificate (Gaikokujin Torokushyomeishyo) Number</li>
                <li>Employment Insurance Number (Koyou Hoken Hihokensha Bango)</li>
                <li>Health Insurance Number (Kenko Hoken Bango)</li>
                <li>Individual Number (My Number)</li>
                <li>National Pension Number (Kiso Nenkin Bango)</li>
                <li>Resident (Zairyuu) Card Number</li>
                <li>Taxpayer Identification Number (Nozeishya Bango)</li>
                <li>Welfare Pension Number (Kosei Nenkin Bango)</li>
            </ul>

            <mat-divider aria-hidden="true" class="field-space"></mat-divider>

            <h3><strong>Kenya:</strong></h3>

            <ul class="ul-no-style">
                <li>Hospital Insurance (NHIF) Number</li>
                <li>National Identity Number</li>
                <li>Revenue Authority PIN</li>
                <li>Social Security (NSSF) Number</li>
            </ul>

            <mat-divider aria-hidden="true" class="field-space"></mat-divider>

            <h3><strong>Korea, Republic of:</strong></h3>

            <ul class="ul-no-style">
                <li>Resident Registration Number (RRN)</li>
            </ul>

            <mat-divider aria-hidden="true" class="field-space"></mat-divider>

            <h3><strong>Laos:</strong></h3>

            <ul class="ul-no-style">
                <li>National ID Card</li>
            </ul>

            <mat-divider aria-hidden="true" class="field-space"></mat-divider>

            <h3><strong>Luxembourg:</strong></h3>

            <ul class="ul-no-style">
                <li>Social Security Number (CCSS)</li>
            </ul>

            <mat-divider aria-hidden="true" class="field-space"></mat-divider>

            <h3><strong>Malaysia:</strong></h3>

            <ul class="ul-no-style">
                <li>ASB Membership Number</li>
                <li>National Identity Number (New IC)</li>
                <li>National Identity Number (Old IC)</li>
                <li>PNB Number</li>
                <li>Provident Fund (KWSP) Number</li>
                <li>SOCSO Number</li>
                <li>Tabung Haji Number</li>
                <li>Tax Reference Number</li>
            </ul>

            <mat-divider aria-hidden="true" class="field-space"></mat-divider>

            <h3><strong>Maldives:</strong></h3>

            <ul class="ul-no-style">
                <li>National ID Card Number</li>
            </ul>

            <mat-divider aria-hidden="true" class="field-space"></mat-divider>

            <h3><strong>Mexico:</strong></h3>

            <ul class="ul-no-style">
                <li>Personal ID Code (CURP)</li>
                <li>Social Security (IMSS) Number</li>
                <li>Taxpayer (RFC) Number</li>
            </ul>

            <mat-divider aria-hidden="true" class="field-space"></mat-divider>

            <h3><strong>Netherlands:</strong></h3>

            <ul class="ul-no-style">
                <li>Personal Number (Burgerservicenr)</li>
            </ul>

            <mat-divider aria-hidden="true" class="field-space"></mat-divider>

            <h3><strong>New Zealand:</strong></h3>

            <ul class="ul-no-style">
                <li>Inland Revenue Department (IRD) Number</li>
            </ul>

            <mat-divider aria-hidden="true" class="field-space"></mat-divider>

            <h3><strong>Nigeria:</strong></h3>

            <ul class="ul-no-style">
                <li>National Identification Number (NIN)</li>
            </ul>

            <mat-divider aria-hidden="true" class="field-space"></mat-divider>

            <h3><strong>Norway:</strong></h3>

            <ul class="ul-no-style">
                <li>Person Number (Fødselsnummer)</li>
            </ul>

            <mat-divider aria-hidden="true" class="field-space"></mat-divider>

            <h3><strong>Peru:</strong></h3>

            <ul class="ul-no-style">
                <li>ID Card (DNI) Number</li>
                <li>Tax (RUC) Number</li>
            </ul>

            <mat-divider aria-hidden="true" class="field-space"></mat-divider>

            <h3><strong>Philippines:</strong></h3>

            <ul class="ul-no-style">
                <li>Pag</li>
                <li>PhilHealth Identification Number (PIN)</li>
                <li>Social Security System (SSS) Number</li>
                <li>Tax Identification Number (TIN)</li>
            </ul>

            <mat-divider aria-hidden="true" class="field-space"></mat-divider>

            <h3><strong>Poland:</strong></h3>

            <ul class="ul-no-style">
                <li>ID Card (Dowód Osobisty) Number</li>
                <li>Personal Identity (PESEL) Number</li>
                <li>Tax ID Number (NIP)</li>
            </ul>

            <mat-divider aria-hidden="true" class="field-space"></mat-divider>

            <h3><strong>Portugal:</strong></h3>

            <ul class="ul-no-style">
                <li>ID Number (Número de Identificação)</li>
                <li>Social Security Identification Number (NISS)</li>
                <li>Taxpayer ID Number (NIF)</li>
            </ul>

            <mat-divider aria-hidden="true" class="field-space"></mat-divider>

            <h3><strong>Qatar:</strong></h3>

            <ul class="ul-no-style">
                <li>ID Card Number</li>
            </ul>

            <mat-divider aria-hidden="true" class="field-space"></mat-divider>

            <h3><strong>Russia:</strong></h3>

            <ul class="ul-no-style">
                <li>Insert for Labor Book Number</li>
                <li>Internal Passport Number</li>
                <li>Labor Book Number</li>
                <li>RPF (Pension Fund) Registration Number</li>
                <li>Taxpayer Identification Number (INN)</li>
            </ul>

            <mat-divider aria-hidden="true" class="field-space"></mat-divider>

            <h3><strong>Singapore:</strong></h3>

            <ul class="ul-no-style">
                <li>Foreign Identification Number (FIN)</li>
                <li>National Registration Identification Number (NRIC)</li>
            </ul>

            <mat-divider aria-hidden="true" class="field-space"></mat-divider>

            <h3><strong>South America:</strong></h3>

            <ul class="ul-no-style">
                <li>Identity Document or Smart Identity Card ID Number</li>
                <li>Tax Reference Number</li>
            </ul>

            <mat-divider aria-hidden="true" class="field-space"></mat-divider>

            <h3><strong>Spain:</strong></h3>

            <ul class="ul-no-style">
                <li>Alien Identification Number (NIE)</li>
                <li>ID Card (DNI) Number</li>
                <li>Social Security Number (NSS)</li>
                <li>Tax Identification Number (NIF)</li>
            </ul>

            <mat-divider aria-hidden="true" class="field-space"></mat-divider>

            <h3><strong>Sweden:</strong></h3>

            <ul class="ul-no-style">
                <li>Personal ID Number (Personnummer)</li>
            </ul>

            <mat-divider aria-hidden="true" class="field-space"></mat-divider>

            <h3><strong>Switzerland:</strong></h3>

            <ul class="ul-no-style">
                <li>Social Insurance Number (AHV/AVS)</li>
            </ul>

            <mat-divider aria-hidden="true" class="field-space"></mat-divider>

            <h3><strong>Taiwan:</strong></h3>

            <ul class="ul-no-style">
                <li>Alien Resident Certificate (ARC) Number</li>
                <li>National ID Number</li>
            </ul>

            <mat-divider aria-hidden="true" class="field-space"></mat-divider>

            <h3><strong>Thailand:</strong></h3>

            <ul class="ul-no-style">
                <li>ID Card Number</li>
            </ul>

            <mat-divider aria-hidden="true" class="field-space"></mat-divider>

            <h3><strong>United Arab Emirates:</strong></h3>

            <ul class="ul-no-style">
                <li>Alien ID Card Number</li>
                <li>ID Card Number</li>
            </ul>

            <mat-divider aria-hidden="true" class="field-space"></mat-divider>

            <h3><strong>United Kingdom:</strong></h3>

            <ul class="ul-no-style">
                <li>National Insurance (NI) Number</li>
            </ul>

            <mat-divider aria-hidden="true" class="field-space"></mat-divider>

            <h3><strong>United States of America:</strong></h3>

            <ul class="ul-no-style">
                <li>Social Security Number (SSN)</li>
            </ul>
        </mat-card-content>
    </mat-card>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-raised-button class="close-button" mat-dialog-close>
        Close
    </button>
</mat-dialog-actions>